import React, { useEffect, useState } from 'react';
import '../../assets/css/Antenne/Antenne_Blog.css';
import { API_BASE_URL } from '../../utils/config';
import Loader from '../Loader'; // Composant Loader personnalisé
import LazyMedia from '../LazyMedia'; // Import du composant LazyMedia

function BlogSection({ antenneId }) {
    const [images, setImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isZoomed, setIsZoomed] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const fetchImages = async (page = 1) => {
        try {
            setIsLoading(true);
            const response = await fetch(`${API_BASE_URL}/medias/${antenneId}/?page=${page}`);
            if (!response.ok) throw new Error('Erreur lors de la récupération des images.');
            const data = await response.json();
            setImages(data.files || []);
            setTotalPages(data.total_pages || 1);
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchImages(currentPage);
    }, [currentPage]);

    const closeLightbox = (e) => {
        if (e.target.classList.contains('lightbox-image')) return;
        setSelectedImage(null);
        setIsZoomed(false);
    };

    const toggleZoom = () => {
        setIsZoomed((prevZoom) => !prevZoom);
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="blog-section">
            <h2 className="section-title">Blog Photo</h2>

            {/* Affichage conditionnel du loader */}
            <div className={`blog-gallery ${isLoading ? 'loading' : ''}`}>
                {isLoading ? (
                    <div className="loader-overlay-blog">
                        <Loader />
                    </div>
                ) : images.length > 0 ? (
                    images.map((image, index) => (
                        <div key={index} className="blog-image-wrapper">
                            <LazyMedia
                                type="image"
                                src={image}
                                alt={`Image ${index + 1}`}
                                className="blog-image"
                                onClick={() => setSelectedImage(image)}
                                onError={(e) => (e.target.src = 'https://via.placeholder.com/300')}
                            />
                        </div>
                    ))
                ) : (
                    <p>Aucune image disponible.</p>
                )}
            </div>

            {selectedImage && (
                <div className="lightbox" onClick={closeLightbox}>
                    <span className="close" onClick={() => setSelectedImage(null)}>
                        &times;
                    </span>
                    <img
                        src={selectedImage}
                        alt="Zoomed"
                        className={`lightbox-image ${isZoomed ? 'zoomed' : ''}`}
                        onClick={toggleZoom}
                    />
                </div>
            )}

            <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    Précédent
                </button>
                <span>
                    Page {currentPage} sur {totalPages}
                </span>
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    Suivant
                </button>
            </div>
        </div>
    );
}

export default BlogSection;
